import { TableHeaderCategoryConfig } from "../../../../../components/tables/tableContext/TableContext";

import { CollectionErrorsDataInterface } from "../../../../../redux/interfaces/reports.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

export const collectionErrorsSimplifiedTableHeader: TableHeaderCategoryConfig[] =
  [
    {
      label: "Username colector",
      value: "usernameColector",
      minW: 125,
    },
    {
      label: "Nume colector",
      value: "numeColector",
      minW: 125,
    },
    {
      label: "Username verificator",
      value: "usernameVerificator",
      minW: 125,
    },
    {
      label: "Nume verificator",
      value: "numeVerificator",
      minW: 125,
    },
    {
      label: "Cantitate minus",
      value: "cantitateMinus",
      minW: 125,
    },
    {
      label: "Cantitate plus",
      value: "cantitatePlus",
      minW: 125,
    },
    {
      label: "Lot si BBD",
      value: "lotBBD",
      minW: 125,
    },
    {
      label: "Data verificarii",
      value: "dataVerificarii",
      minW: 125,
    },
  ];

export const getCollectionErrorsSimplifiedTableData: any = (
  collectionErrorsList: CollectionErrorsDataInterface[],
) =>
  collectionErrorsList?.map((item) => {
    return {
      id: item.id_greseala,
      crudData: item,
      data: [
        {
          title: item.usernameColector,
        },
        {
          title: item.numeColector,
        },
        {
          title: item.usernameVerificator,
        },
        {
          title: item.numeVerificator,
        },
        {
          title: item.cantitateMinus ?? "-",
        },
        {
          title: item.cantitatePlus ?? "-",
        },
        {
          title: item.lotBBD ?? "-",
        },
        {
          badges: [
            {
              badgeText: getDateAndTime(item.dataVerificarii) ?? "-",
              badgeColor: "light-primary",
            },
          ],
        },
      ],
    };
  });
